<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="controlColumn"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Define variance control column
                    </b>
                    <span>
                        e.g. “pre-post”, “2018 vs. 2019”, “AB”, “budget vs. actuals”, etc.
                    </span>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading':!dataLoaded, 'middle-part' :true, 'set-up':true}">
            <div class="current-status">
                <div class="left">
                    <div class="dot green"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div *ngIf="!namedRangesFoundInFile.length" class="wrap">
                        No valid <b>import tags</b> found in source file <help-link></help-link>
                    </div>
                    <div *ngIf="namedRangesFoundInFile.length" class="wrap">
                        These valid <b>import tags</b> were found in the source file <help-link></help-link>: <i>{{namedRangesFoundInFile.join(', ')}}</i>
                    </div>
                    <div class="wrap">
                        <b class="text-bracket" *ngIf=selectedColumn>{{selectedColumn.name}}</b> selected as <b>control</b> column – click
                        on another column with 50 values or less to change <help-link helpId="15"></help-link>
                    </div>
                    <div *ngIf="columns" class="wrap">
                        Analyze variance between
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="selectedOldControlValue">
                              <mat-option *ngFor="let v of selectedColumn.usefulVals" [value]="v" (onSelectionChange)="oldControlValChanged($event)">
                                {{v}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                        on the left and
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="selectedNewControlValue">
                              <mat-option *ngFor="let v of selectedColumn.usefulVals" [value]="v" (onSelectionChange)="newControlValChanged($event)">
                                {{v}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                        on the right
                    </div>
                    <div class="wrap">
                        <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-green':true, 'btn-small':true}">Continue</button>
                    </div>
                </div>
            </div>
            <div class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" (click)="selectColumn(col)" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <ng-container *ngIf="col.isNumerical">
                                <b class="green">#</b>,&nbsp;
                            </ng-container>
                            {{ displayRoughNum(col.uniqueValues) }}
                        </td>
                        <!-- <td class="eligible">
                            >1000
                        </td> -->
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length">
                                <div class="gray">
                                    {{col.someVals[0]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                                <div class="gray">
                                    {{col.someVals[1]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                                <div class="gray">
                                    {{col.someVals[2]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                                <div class="gray">
                                    {{col.someVals[3]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                                <div class="gray">
                                    {{col.someVals[4]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
